import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import { request } from 'meinian-package/src/utils'
import { Icon } from 'meinian-package/src/component'
import { PopoverCard } from 'meinian-package/src/baseComponent/dropdown'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import styles from './index.module.less'

export default () => {
  const [recentColls, setRecentColls] = useState([])
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    visible && fetchRecentColls()
  }, [visible])

  const fetchRecentColls = async () => {
    try {
      const res = await request.get('/zhikuan/ins/quick-access/query-quick-access')
      setRecentColls(res.slice(0, 9))
    } catch (err) {
      console.error(err)
    }
  }

  const content = (<div className={styles.fastAccessWrapContent}>
    <div className="fastAccessWrapContentTitle"><span className="text">快速访问</span> <span className="num">{recentColls.length}/9</span></div>
    <div className="fastAccessWrapContentList">
      {
            recentColls.map(coll => <div
              className="fastAccessWrapContentListItem"
              onClick={() => {
                const link = coll.parentEntityId && coll.parentEntityId !== -1
                  ? `/meinian/home/coll/detail/${coll.entityId}?tab=1&inspirationId=${coll.entityId}&parentId=${coll.parentEntityId}&name=${coll.entityName}&trackSourceType=快速访问`
                  : `/meinian/home/coll/detail/${coll.entityId}?inspirationId=${coll.entityId}&trackSourceType=快速访问`

                window.open(link)
              }}
            >
              <div className="fastAccessWrapContentListItemText">{coll.entityName}</div>
              <Icon
                type="m-guanbi"
                className="fastAccessWrapContentListItemClose"
                onClick={(e) => {
                  e.stopPropagation()
                  request.get('/ins/quick-access/remove-quick-access', { params: { id: coll.id } }).then(() => {
                    fetchRecentColls()
                    emitter.emit(EmitterEvents.fastAccess)
                    message.success('删除成功')
                  })
                }}
              />
            </div>)
        }
    </div>
  </div>)

  return <PopoverCard
    placement="rightTop"
    content={content}
    trigger="hover"
    overlayStyle={{ paddingLeft: '8px' }}
    overlayClassName={styles.fastAccessPopover}
    onVisibleChange={vis => setVisible(vis)}
    visible={visible}
  >
    <div className={styles.fastAccessWrap}>
      <Icon type="m-kuaisufangwen_tianchong" className="fast-access-wrap-icon" />
    </div>
  </PopoverCard>
}
